import { useStore } from 'zustand';

import { applicationStore, type ApplicationStore } from '@/store/application';

/**
 * Custom hook to access the `ApplicationStore` using a selector function.
 *
 * Reads from the module-level {@link applicationStore} singleton via Zustand's
 * `useStore`, so it does not require an `ApplicationProvider` ancestor.
 *
 * @template TSelectorOutput - The type of the selected output from the store.
 * @param selector - A function that receives the `ApplicationStore` and returns the desired piece of state.
 * @returns The selected output from the store.
 */
export const useApplicationStore = <TSelectorOutput>(selector: (store: ApplicationStore) => TSelectorOutput) => {
  return useStore(applicationStore, selector);
};
